import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import { mixin } from './js/ciam-mixin.js'
import { CiamUrlParams } from './js/utils.js'
import repository from './js/api/repository.js'
import recaptcha from './js/recaptcha.js'
import { defaults } from './js/defaults.js'
import Vuelidate from 'vuelidate'
import DocumentTitle from './components/DocumentTitle.vue'
import axios from 'axios'
import UAParser from 'ua-parser-js'

axios.defaults.headers.get['Content-Type'] = 'application/json'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.put['Content-Type'] = 'application/json'
axios.defaults.headers.patch['Content-Type'] = 'application/json'
axios.defaults.withCredentials = true
axios.interceptors.request.use(request => {
  console.debug(`[>>][${request.method.toUpperCase()}][${request.url}]`)
  return request
})
axios.interceptors.response.use(function (response) {
  console.debug(`[<<][${response.config.method.toUpperCase()}][${response.config.url}][${response.status}]`)
  return response
}, function (error) {
  console.debug(`[<<][${error.config.method.toUpperCase()}][${error.config.url}][${error.response.status}]`)
  return Promise.reject(error)
})

Vue.use(Vuelidate)
Vue.component('document-title', DocumentTitle)
Vue.config.productionTip = false

Vue.prototype.$api = repository
Vue.prototype.$defaults = defaults(store.state.isRememberMeEnabledByDefault)
Vue.prototype.$recaptcha = recaptcha

/* global contextPath */
/* global landingPage */
/* global landingPageParams */
/* global landingErrors */
/* global autoResume */
/* global brand */
/* global showError */

console.log('Brand: ' + brand)

require('@/assets/css/style.css')
require('@/assets/css/brand/' + brand.toLowerCase() + '/custom.css')

// commit the brand to the store in error page case, because there is no initial state
// TODO: maybe move the error info into a state object like initial state
store.commit('brand', brand)

window.vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

// route to specific page on SPA loading or default route
if (landingPage) {
  console.debug('routing to ' + JSON.stringify(landingPage))
  console.debug('with params ' + JSON.stringify(landingPageParams))

  if (landingPage === 'RESUME2APP') {
    console.debug('Resuming to app')
    mixin.methods.resumeToApp(landingPageParams.redirect)
  }

  router.push({
    name: landingPage, // goto the result page
    params: landingPageParams
  })
}

// Send user agent to backend for logging
const parser = UAParser()
const xmlHttp = new XMLHttpRequest()
xmlHttp.open('POST', contextPath + '/ua', false)
xmlHttp.setRequestHeader('Content-Type', 'application/json')
xmlHttp.send(JSON.stringify({ browserName: parser.browser.name, browserVersion: parser.browser.version, osName: parser.os.name }))

// redirect back to PF immediately
if (autoResume) {
  console.debug('resuming to PF...')
  mixin.methods.submitRequest(store.state.urlPF + store.state.resume, { token: store.state.token })
}

// display error on SPA loading
if (landingErrors) {
  console.debug('adding landingErrors...')
  $('form.ui.form').form('add errors', landingErrors)
}

console.debug('Vue app started!')

// add support for page refresh
if (mixin.methods.areCookiesActive() && !showError) {
  const currentURL = new CiamUrlParams(window.location.search)
  if (currentURL.has('request_info')) {
    console.debug('cleaning URL ...')
    currentURL.delete('resume') // TODO remove after SL removes it from adapter
    currentURL.delete('request_info')
    const path = landingPage === 'GOTO_REGISTRATION' ? '/ciam/auth/login#/register' : window.location.pathname
    const newURL = path + currentURL.toString()
    window.history.pushState({}, document.title, newURL)
  }
}
